export default __webpack_public_path__ + "static/media/Salnikov-1.8a901c44.jpg";